import { render, staticRenderFns } from "./BankDeposits.vue?vue&type=template&id=21e626fa&"
import script from "./BankDeposits.vue?vue&type=script&lang=js&"
export * from "./BankDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports